module.exports = __webpack_public_path__ + "static/img/12.dffc9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12.png
// module id = SVKk
// module chunks = 1